import { ref, type Ref } from 'vue'

export const useLoading = <T extends Array<any>, U>(fn: (...args: T) => Promise<U>): [ Ref<boolean>, (...args: T) => Promise<U> ] => {
  const loading = ref(false)
  const wrapped = async (...args: T) => {
    loading.value = true
    const value = await fn(...args)
    loading.value = false
    return value
  }
  return [
    loading,
    wrapped
  ]
}
